import React, { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import * as bie from "react-bootstrap";
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import * as Yup from 'yup';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import { viewImage } from '../../CommonUtils/viewImage';
import Swal from 'sweetalert2';
import { AllowFloats } from '../../CommonUtils/CommonValidations';
import { FaEye } from 'react-icons/fa';
import { GetCollegeType } from '../../Reducers/AffiliationCommonservice';
import { useSelector } from 'react-redux';
export default function FfcaLabDetailsArea_21() {
    const LandType = useSelector((state) => state?.commonMastersReducer?.CollegeType);
    const ffcalabvalidations = Yup.object({
        data: Yup.array().of(Yup.object().shape({
            ffcaStatus: Yup.string().required(ERROR_MSG).nullable(),
            ffcaArea: Yup.string().required(ERROR_MSG).nullable(),
        })),
    })
    const FfcaLabDetailsFormik = useFormik({
        initialValues: {
            data: [{
                ffcaStatus: "",
                ffcaDeficiency: "",
                ffcaArea: "",
                slno: "",
            }]

        },
        validationSchema: ffcalabvalidations,
        onSubmit: (values) => {
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.API_URL + "updateFfcaLabdetails";
                    CommonAxiosPost(url, values?.data).then((res) => {
                        if (res?.data?.scode === "01") {
                            successAlert2(res?.data?.sdesc);
                            GetLabDetails();

                        }
                        else {
                            failureAlert("Failed to Submit")

                        }
                    })
                }
            })
        }
    })

    const [labData, setlabData] = useState([]);
    function GetLabDetails() {
        let url = config.url.API_URL + "getlabdetails";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setlabData(res?.data?.labdetails);
                res?.data?.labdetails?.forEach((labdata, i) => {
                    FfcaLabDetailsFormik?.setFieldValue(`data[${i}].slno`, labdata?.slno);
                    FfcaLabDetailsFormik?.setFieldValue(`data[${i}].ffcaStatus`, labdata?.ffca_status);
                    FfcaLabDetailsFormik?.setFieldValue(`data[${i}].ffcaArea`, labdata?.ffca_area);
                    FfcaLabDetailsFormik?.setFieldValue(`data[${i}].ffcaDeficiency`, labdata?.ffca_deficiency);
                })
            } else {
                setlabData([])

            }
        })
    }
    useEffect(() => {
        GetCollegeType();

        GetLabDetails();
    }, [])
    const [calculatedValue, setCalculatedValue] = useState({});

    const handleAreaChange = (e, area, index) => {
        const inputValue = parseFloat(e.target.value) || 0;
        const result = inputValue - area;
        setCalculatedValue(prevState => {
            const newCalculatedValue = { ...prevState, [index]: result > 0 ? result : 0 };
            FfcaLabDetailsFormik?.setFieldValue(`data[${index}].ffcaDeficiency`, newCalculatedValue[index]);
            return newCalculatedValue;
        });
    };
    return (
        <>
            <CommonFormHeading heading="Laboratory Report" />
            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                <FormikProvider value={FfcaLabDetailsFormik}>
                    <Form onChange={FfcaLabDetailsFormik.handleChange} onSubmit={FfcaLabDetailsFormik.handleSubmit} className="affl-form" >
                        <bie.Row className="px-2 pt-3 mb-3">
                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                    <thead>
                                        <tr>

                                            <th className='cen'> Sl no</th>
                                            <th style={{ width: "15%" }} >Lab Type</th>
                                            <th style={{ width: "15%" }} >Lab Name	</th>
                                            <th style={{ width: "10%" }}> Building/Block Name	</th>
                                            <th>Area in ({LandType})</th>
                                            <th> Lab Image</th>
                                            <th style={{ width: "10%" }}> Is the Picture of the Lab submitted by college and the Lab really the same Yes/No	</th>
                                            <th> Status of Utilization	</th>
                                            <th>Area that shall be provided as Per the Norms of the University( {LandType})	</th>
                                            <th>Deficiency ({LandType})</th>

                                        </tr>

                                    </thead>
                                    <tbody>
                                        {labData?.map((empdata, index) => (
                                            <tr key={index}>
                                                <td className='cen'>{index + 1}</td>
                                                <td className='text-left'> {empdata?.lab_type}</td>
                                                <td className='text-left'>{empdata?.lab_details}</td>
                                                <td className='text-left'>{empdata?.block_name ? empdata?.block_name : "-"}</td>
                                                <td>{empdata?.area}</td>
                                                <td>{empdata?.building_img ? (
                                                    <button type="button" className="btn btn-primary" onClick={() => { viewImage(empdata?.building_img) }}><FaEye size={20} /></button>
                                                ) : (
                                                    <span>-</span>
                                                )}</td>
                                                <td>
                                                    <Field type="hidden" name={`data[${index}].slno`} className="form-control" />
                                                    <div>
                                                        <Field as="select" name={`data[${index}].ffcaStatus`} className="form-control">
                                                            <option value=''>--SELECT--</option>
                                                            <option value='true'>Yes</option>
                                                            <option value='false'>No</option>
                                                        </Field>

                                                        <ErrorMessage name={`data[${index}].ffcaStatus`} component="div" className="text-error" />
                                                    </div>
                                                </td>
                                                <td>{empdata?.utilization === true ? "Yes" : "No"}</td>

                                                <td>
                                                    <Field type="text" name={`data[${index}].ffcaArea`} className="form-control" maxlength="10"
                                                        onKeyUp={(e) => handleAreaChange(e, empdata?.area, index)} onKeyPress={(e) => { AllowFloats(e); }} />
                                                    <ErrorMessage name={`data[${index}].ffcaArea`} component="div" className="text-error" />
                                                </td>

                                                <td>
                                                    <Field
                                                        type="hidden"
                                                        name={`data[${index}].ffcaDeficiency`}
                                                        value={calculatedValue[index] !== undefined ? calculatedValue[index] : empdata?.ffca_deficiency}
                                                    />
                                                    {calculatedValue[index] !== undefined ? calculatedValue[index] : empdata?.ffca_deficiency}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>


                            <div className="button-cend pt-1 mb-3">
                                <button type='submit' className='btn btn-success btn-sm float-end rounded mb-2'>Submit</button>
                            </div>
                        </bie.Row>
                    </Form>
                </FormikProvider>
            </bie.Container>
        </>
    )
}
